export const FEATURE_FLAG_KEYS = {
  freezeAfterReview: 'freeze_after_review',
  reviewParserV2: 'review_parser_v2',
  lineItemsPage: 'line_items_page',
};

export const DEFAULT_FLAG_VALUES = {
  [FEATURE_FLAG_KEYS.freezeAfterReview]: false,
  [FEATURE_FLAG_KEYS.reviewParserV2]: true,
  [FEATURE_FLAG_KEYS.lineItemsPage]: true,
};

const RAW_ALLOW = ['/review', '/', '/upload', '/login', '/signup', '/logout', '/compare', '/new'];

export function getLaunchDarklyClientId() {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    const env = import.meta.env;
    return (
      env.VITE_LAUNCHDARKLY_CLIENT_ID ||
      env.VITE_LD_CLIENT_ID ||
      env.VITE_LD_CLIENT_KEY ||
      ''
    );
  }
  if (typeof process !== 'undefined' && process.env) {
    const env = process.env;
    return env.VITE_LAUNCHDARKLY_CLIENT_ID || env.VITE_LD_CLIENT_ID || env.VITE_LD_CLIENT_KEY || '';
  }
  return '';
}

export function shouldFreezeAfterReview(flagState = {}) {
  return !!flagState?.[FEATURE_FLAG_KEYS.freezeAfterReview];
}

export function isAllowedPath(pathname, flagState = {}) {
  if (!shouldFreezeAfterReview(flagState)) return true;
  if (!pathname) return false;
  if (pathname === '/review' || pathname.startsWith('/review/')) return true;
  return RAW_ALLOW.includes(pathname);
}
